import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics/FctParams';
import { votingEscrowContract } from '../helpers/supportedContracts';
export var Withdraw = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'withdraw',
    name: 'withdrawCurveToken',
    description: 'Withdraw deposited CRV tokens once a lock has expired.',
    supportedContracts: votingEscrowContract,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'curve_voting_escrow', options: votingEscrowContract }),
            methodParams: {},
        },
        output: {},
    }); },
});
